<template>
  <div class="navbar-header-model" v-show="tabs.length">
    <tabs v-model="selectedTab">
      <tab
        v-for="(tab, i) in tabs"
        :key="`t${i}`"
        :val="i"
        :label="tab.name"
        :indicator="true"
        @click="$emit('changeSession', { part: i, session: 0 })"
      />
      <!--
      <tab :key="`t${tabs.length}`" :val="tabs[(tabs.length - 1)]?.name" :label="translate.soon" :disabled="true"
        class="disable" />
      -->
    </tabs>
    <tab-panels v-model="selectedTab" :animate="true" :swipeable="true">
      <tab-panel v-for="(tab, i) in tabs" :key="`tp${i}`" :val="i" class="font-tab">
        <div class="row d-flex justify-content-start">
          <div v-for="(part, j) in tab.sessions" :key="j" class="card px-3 pt-3 col-lg-3">
            <div
              v-if="thumbPhotos[i][j] && part.block === 'false'"
              :class="
                part.block === 'false'
                  ? sessionActive == j
                    ? 'card-box-active'
                    : 'card-box'
                  : 'card-box-block'
              "
              @click="
                part.block === 'true'
                  ? showModalPlans('Clicar em uma sessão de fotos bloqueada')
                  : $emit('changeSession', { part: i, session: j })
              "
              :style="`background-image: url('${thumbPhotos[i][j]}');background-size:cover;background-repeat: no-repeat;background-position: center center`"
            >
              <font-awesome-icon v-if="part.block === 'true'" :icon="['fas', 'lock']" size="md" />
            </div>
            <div
              v-else-if="part.block === 'true'"
              :class="
                part.block === 'false'
                  ? sessionActive == j
                    ? 'card-box-active'
                    : 'card-box'
                  : 'card-box-block'
              "
              @click="
                part.block === 'true'
                  ? showModalPlans('Clicar em uma sessão de fotos bloqueada')
                  : $emit('changeSession', { part: i, session: j })
              "
            >
              <font-awesome-icon v-if="part.block === 'true'" :icon="['fas', 'lock']" size="md" />
            </div>
            <div
              v-else
              :class="
                part.block === 'false'
                  ? sessionActive == j
                    ? 'card-box-active'
                    : 'card-box'
                  : 'card-box-block'
              "
              @click="
                part.block === 'true'
                  ? showModalPlans('Clicar em uma sessão de fotos bloqueada')
                  : $emit('changeSession', { part: i, session: j })
              "
            >
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <span
              style="right: -15px"
              :class="
                part.block === 'false'
                  ? sessionActive == j
                    ? 'part-name py-1'
                    : 'part-name-gray py-1'
                  : 'part-name-block py-1'
              "
              >{{ part.name }}</span
            >
          </div>
        </div>
      </tab-panel>
    </tab-panels>
    <hr />
  </div>
</template>
<script lang="ts">
  import { isMobile } from 'views/shared/utils/mobile'
  import { defineComponent } from 'vue'
  import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs'
  import { event } from 'vue-gtag'

  export default defineComponent({
    name: 'NavBarPartsModel',
    components: {
      Tabs,
      Tab,
      TabPanels,
      TabPanel
    },
    emits: ['changeSession', 'showModalSubscribePlans'],
    props: ['parts', 'translate', 'sessionActive', 'changeSelectedTab', 'thumbPhotos'],
    watch: {
      parts: function (value) {
        this.tabs = value
        this.selectedTab = this.changeSelectedTab
      },
      changeSelectedTab: function (value) {
        this.selectedTab = value
      }
    },
    created() {
      this.tabs = this.parts
      if (this.tabs.length) this.selectedTab = this.changeSelectedTab
    },
    data() {
      return {
        selectedTab: '',
        isMobile: isMobile(),
        tabs: [],
        showSubscribe: false
      }
    },
    methods: {
      showModalPlans(acionador: string) {
        this.$emit('showModalSubscribePlans', true)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'paywall',
          paywall: { acionador: acionador }
        })
        event('paywall2', { paywall: { acionador: acionador } })
      }
    }
  })
</script>
<style scoped>
  .tab-panels >>> .tab-panel {
    width: 97%;
  }
  .navbar-header-model >>> .tab {
    height: 64px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 61px;
    top: 5px;
  }
  .navbar-header-model .tabs > .active {
    border: 0px;
  }
  .navbar-header-model .tabs > .active::after {
    content: '';
    background: #000000;
    position: absolute;
    width: 100%;
    height: 3px;
    bottom: 0px;
  }
  .tabs >>> .tab {
    padding: 0px 20px;
    cursor: pointer;
  }
  .tabs >>> .active .tab {
    color: #000000;
    border-color: #000000;
    font-weight: bold;
    font-family: 'Roboto-Bold';
  }
  .button--more svg {
    color: #b20000;
  }
  .button--more {
    font-family: 'Exo-2';
    font-weight: bold;
    color: #898989;
    font-size: 16px;
  }
  .small svg {
    margin-right: 5px;
  }
  .card img {
    width: 470px;
    height: 701px;
    object-fit: cover;
  }
  .card {
    background-color: #fff;
  }
  .card-box {
    width: 83px;
    height: 83px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 10%;
    border: 1px solid #dddddd;
    cursor: pointer;
    opacity: 0.6;
  }
  .card-box-active {
    width: 83px;
    height: 83px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 10%;
    border: 2px solid #b20000;
    border: 1px solid #000000;
    cursor: pointer;
    transform: scale(1.05);
  }
  .card-box-block {
    width: 83px;
    height: 83px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10%;
    border: 1px solid #dddddd;
    background-color: #eeeeee;
    cursor: pointer;
  }
  .part-name {
    color: #5b5858;
    font-family: 'Roboto-Bold';
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
  }
  .part-name-gray {
    color: #5b5858;
    font-family: 'Roboto-Bold';
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
  }
  .part-name-block {
    opacity: 0.5;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 12px;
    letter-spacing: 0;
    text-align: center;
    margin-top: 3px;
  }
  .fa-lock {
    color: #b20000;
  }
  .disable {
    cursor: not-allowed;
  }
  .col-lg-3 {
    width: 25%;
  }
  /* regras mobile 1300px */
  @media screen and (max-width: 1300px) {
    .col-lg-3 {
      width: 33.33%;
    }
  }
</style>
